import { ApiService } from 'services/api.service';
import { AddressVerificationForm } from 'components/addressVerificationForm/addressVerificationForm';
import { AddressVerificationService } from 'services/addressVerification.service';
import { CheckoutService } from 'services/checkout.service';
import { Badge } from 'components/badge/badge';
import { AddressForm } from 'components/addressForm/addressForm';
import { SaveAndCancel } from 'components/saveAndCancel/saveAndCancel';
import { DisplayStateName } from 'components/displayStateName/displayStateName';
import { DisplayCountryName } from 'components/displayCountryName/displayCountryName';

import template from './savedShippingAddress.html';
import './savedShippingAddress.scss';

export const SavedShippingAddress = angular
    .module('checkout.components.editAccountContactAndDelivery.savedShippingAddress', [
        AddressVerificationForm,
        AddressVerificationService,
        ApiService,
        CheckoutService,
        Badge,
        AddressForm,
        SaveAndCancel,
        DisplayStateName,
        DisplayCountryName
    ]).component('savedShippingAddress', {
        template,
        bindings: {
            address: '<',
            onAddressEdited: '<',
            onAddressDeleted: '<',
            showDeleteButton: '<',
            isShippingRequired: '<',
            useAddressVerification: '<',
            useNewCarts: '<'
        },
        controller: class SavedShippingAddressCtrl {
            constructor(addressVerificationService, apiService, checkoutService, $rootScope) {
                this.addressVerificationService = addressVerificationService;
                this.apiService = apiService;
                this.checkoutService = checkoutService;
                this.$rootScope = $rootScope;

                this.updateAddress = this.updateAddress.bind(this);
            }

            $onInit() {
                this.unbindListener = this.$rootScope.$on('editAccountContactAndDelivery:Editing', (event, data) => {
                    if (data !== this.address.id) {
                        this.clearAddressSuggestions();
                        this.onCancelClicked();
                    }
                });
            }

            $onDestroy() {
                this.unbindListener();
            }

            $onChanges(changesObj) {
                if (changesObj.address && !changesObj.address.isFirstChange()) {
                    this.setAddressModel(changesObj.address.currentValue);
                }
            }

            setAddressModel(address) {
                this.addressModel = angular.copy(address);
            }

            onEditClicked() {
                this.isEditing = true;
                this.setAddressModel(this.address);
                this.$rootScope.$emit('editAccountContactAndDelivery:Editing', this.address.id);
            }

            onCancelClicked() {
                this.isEditing = false;
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;
                this.setAddressModel(this.address);
            }

            onSaveClicked() {
                if (this.editShippingAddressForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editShippingAddressForm['$ctrl.addressForm']);
                    return;
                }
                this.addressSaving = true;

                if (this.useNewCarts && this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.addressModel.address)
                        .then(({ verified, changes, recommendations }) => {
                            if (!verified || changes) {
                                this.addressSaving = false;

                                this.showAddressSuggestion = true;
                                this.addressRecommendations = recommendations;
                                this.addressChanges = changes;
                            } else {
                                this.updateShippingAddress();
                            }
                        });
                } else {
                    this.updateShippingAddress();
                }
            }

            onDeleteClicked() {
                this.showDeleteConfirm = true;
            }

            onCancelDeleteClicked() {
                this.showDeleteConfirm = false;
            }

            onConfirmDeleteClicked() {
                this.isDeleting = true;
                this.apiService.account.shippingAddress.delete(this.addressModel.id)
                    .then(() => this.onAddressDeleted())
                    .finally(() => {
                        this.isDeleting = false;
                        this.showDeleteConfirm = false;
                    });
            }

            updateAddress(newAddress) {
                this.clearAddressSuggestions();

                if (newAddress) {
                    this.addressModel.address = { ...this.addressModel.address, ...newAddress };
                    this.addressSaving = true;
                    this.updateShippingAddress();
                }
            }

            updateShippingAddress() {
                this.apiService.account.shippingAddress.update(this.addressModel.id, this.addressModel)
                    .then(() => {
                        return this.onAddressEdited().then(() => {
                            this.isEditing = false;
                        });
                    }).finally(() => {
                        this.addressSaving = false;
                    });
            }

            clearAddressSuggestions() {
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountContactAndDelivery/savedShippingAddress/savedShippingAddress.js